import {
  mobileNetworkOperatorFilterAtom,
  mnoNamesFilterAtom,
  simProductsMobileNetworkOperatorIdFilterAtom,
} from 'atoms/filters/sim-products';
import { mnoHintsAtom } from 'atoms/hints/sim-products';
import { MNOSearchFilter } from 'src/common/components/Filters/Inputs/mnos/MNOSearchFilter';

export const MnoSearchInput = () => {
  return (
    <MNOSearchFilter
      mnoFilterAtom={mobileNetworkOperatorFilterAtom}
      mnoNamesFilterAtom={mnoNamesFilterAtom}
      mnoHintsAtom={mnoHintsAtom}
      mnoIdFilterAtom={simProductsMobileNetworkOperatorIdFilterAtom}
    />
  );
};
